export enum EmailRequestType {
  REPLY = 'reply',
  CREATE = 'create',
  FORWARD = 'forward',
  ARCHIVE = 'archive',
  INBOX = 'inbox',
  READ = 'read',
  UNREAD = 'unread',
  SPAM = 'spam',
  TRASH = 'trash',
  DRAFT = 'draft',
  SEND_DRAFT = 'send_draft',
  DELETE_DRAFT = 'delete_draft',
  MODIFY_LABELS = 'modify_labels',
  MOVE_TO_FOLDER = 'move_to_folder',
  STAR = 'star',
  UNSTAR = 'unstar',
  MARK_IMPORTANT = 'mark_important',
  UNMARK_IMPORTANT = 'unmark_important',
}

export enum DraftEmailType {
  CREATE = 'create',
  REPLY = 'reply',
  FORWARD = 'forward',
}
